import { useIntl } from 'react-intl'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useState } from 'react'
import axios from 'axios'
import { FiX } from 'react-icons/fi'
import { isEmpty } from 'lodash'
import {
  RiSearchLine,
  ASIDE_ICON_MUTED,
  ASIDE_TEXT,
} from './asideStyles'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

export function AsideMenuMain({ data }: any) {
  const intl = useIntl()

  const [searchVal, setSearchVal] = useState('')
  const [timer, setTimer]: any = useState()
  const [searchedModules, setSearchedModules]: any = useState([])
  const [isSearching, setIsSearching] = useState(false)

  const getSearchedModules = (searchString: string) => {
    axios.get(`${API_URL}/get-dashboard-module?search=${searchString}`).then((res) => {
      const updatedData = []
      for (let item of res.data?.data?.module) {
        const routeData: any = {
          title: item?.name,
          route: item?.alias,
          subRoutes: [],
        }
        for (let subRoute of item?.children) {
          routeData.subRoutes.push({ title: subRoute?.name, route: subRoute?.alias })
        }
        updatedData.push(routeData)
      }
      setIsSearching(false)
      setSearchedModules(updatedData)
    })
  }

  const onSearchValChange = (value: string) => {
    setIsSearching(true)
    clearTimeout(timer)
    const newTimer = setTimeout(() => getSearchedModules(value), 500)
    setTimer(newTimer)
    setSearchVal(value)
  }

  const menuData = searchVal ? searchedModules : data

  return (
    <>
      {/* Quick links */}
      <AsideMenuItem
        to='/dashboard'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      />
      <AsideMenuItem to='/profile' title='Profile' />

      {/* Search */}
      <div style={{ padding: '12px 16px' }}>
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <RiSearchLine
            size={15}
            style={{
              position: 'absolute',
              left: 10,
              color: ASIDE_ICON_MUTED,
              pointerEvents: 'none',
            }}
          />
          <input
            type='text'
            placeholder='Search menu'
            style={{
              width: '100%',
              background: '#f5f5f5',
              border: 'none',
              borderRadius: 8,
              padding: '8px 32px',
              fontSize: 13,
              outline: 'none',
              color: ASIDE_TEXT,
            }}
            value={searchVal}
            onChange={(e) => onSearchValChange(e.target.value)}
            data-cy='nav-search'
          />
          {searchVal && (
            <button
              style={{
                background: 'transparent',
                border: 'none',
                position: 'absolute',
                right: 8,
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                padding: 0,
                display: 'flex',
                color: ASIDE_ICON_MUTED,
              }}
              onClick={() => onSearchValChange('')}
            >
              <FiX size={14} />
            </button>
          )}
        </div>
      </div>

      {/* Menu list */}
      {(isSearching && searchVal) || isEmpty(data) ? (
        <p style={{ textAlign: 'center', color: ASIDE_ICON_MUTED, padding: '16px 0', fontSize: 13 }}>
          {isSearching ? 'Searching...' : 'Loading...'}
        </p>
      ) : !isEmpty(menuData) ? (
        menuData.map((routes: any, i: number) => {
          const hasChild = routes.subRoutes && routes.subRoutes.length > 0
          const key = routes.route || routes.title
          return (
            <div key={key}>
              {!hasChild && (
                <AsideMenuItem to={routes.route} title={routes.title} key={i} />
              )}
              {hasChild && (
                <AsideMenuItemWithSub to={routes.route} title={routes.title} key={i}>
                  {routes.subRoutes.map((sub: any, j: number) => (
                    <AsideMenuItem
                      to={sub.route}
                      title={sub.title}
                      isSubItem={true}
                      key={j}
                    />
                  ))}
                </AsideMenuItemWithSub>
              )}
            </div>
          )
        })
      ) : (
        searchVal && (
          <p style={{ textAlign: 'center', color: ASIDE_ICON_MUTED, padding: '16px 0', fontSize: 13 }}>
            Menu not found!
          </p>
        )
      )}
    </>
  )
}
